export default {"src":"/_next/static/media/google_download_badge.3fee99b1.svg","height":36,"width":123,"blurWidth":0,"blurHeight":0};